export default "__VITE_ASSET__1f6ef1a3__"